
import * as types from './types';
import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';
// Mutations Object for ArtistsCatalog. Use it by importing artists/types.js and calling commit() from  artists/actions.js Action File.
export const statementMutations = {
  [types.StatementList.SET.ALL] (state, payload) {
    //console.log("payload.all_artists",payload)
    state.statementList = payload;
    //state.artistsList=payload.all_artists
  },
  [types.StatementList.UPDATE.SINGLE](state,payload){
    state.statementList.statements=state.statementList.statements.map(e => {
      if (e.royalty_period_id == payload.kVal) {
        console.log("::::::::::::::",payload)
        return {
          ...e,
          [payload.name]: payload.value
        };
      } else {
        return e;
      }
    })
  },

  [types.StatementPayment.SET.ALL] (state, payload) {
    //console.log("payload.all_artists",payload)
    state.statementPaymentData = payload;
    //state.artistsList=payload.all_artists
  },
  //...implementSetAllNavTabDetailsMutation(types.BelieveStatementDetails,  'statementDetails'),
  ...implementSetAllNavTabDetailsMutation(types.StatementDetails,  'statementDetails'),
}